"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInfiniteScroll = useInfiniteScroll;
const react_1 = require("react");
const use_identity_ref_1 = require("../use-identity-ref");
const on_1 = require("../../helpers/on");
/**
 * Реализует подписку на событие полной прокрутки списка.
 * @param ref Реф прокручиваемого элемента.
 * @param options Опции.
 * @param options.onFullScroll Сработает при событии полной прокрутки.
 * @param options.threshold Отступ от конца списка по которому событие должно срабатывать.
 * @param moreDeps Зависимости эффекта (нужны, когда ref заполняется не на этапе render'а).
 */
function useInfiniteScroll(ref, { onFullScroll, threshold = 0, }, moreDeps) {
    const callbackRef = (0, use_identity_ref_1.useIdentityRef)(onFullScroll);
    (0, react_1.useEffect)(() => {
        const element = ref.current;
        if (element) {
            return (0, on_1.on)(element, 'scroll', event => {
                const { scrollTop, clientHeight, scrollHeight } = event.target;
                const bottom = threshold + scrollTop + clientHeight;
                const isFullyScrolled = bottom >= scrollHeight;
                isFullyScrolled && callbackRef.current?.(event);
            });
        }
    }, [ref, threshold, ...(moreDeps || [])]);
}
//# sourceMappingURL=index.js.map